import { ADProps, InitProps } from '../types'
import { FlightViewMapLibMap } from '../map'
import { FlightViewMapLibCities } from '../cities'
import L from 'leaflet'
import { getDelays } from './api'
import './ad.css'
import { ADAirport, ADDelay } from './types'
import { calculateIconSize, sleep } from '../utils'
import { FlightViewMapLibADLegend } from './legend'

const REFRESH_DELAY = 10 * 60 * 1000 // 10 min
const RETRY_DELAY = 30 * 1000 // 30 sec

export class FlightViewMapLibAD {
  props: ADProps

  // modules
  mapModule: FlightViewMapLibMap
  legend: FlightViewMapLibADLegend
  cities: FlightViewMapLibCities

  // map
  map: L.Map

  timeFormat: string
  dateFormat: string
  locale: string

  constructor (parentElement: HTMLElement, initProps: InitProps) {
    this.props = initProps.ad
    this.mapModule = new FlightViewMapLibMap(parentElement, initProps)
    this.map = this.mapModule.map
    this.timeFormat = initProps.timeFormat
    this.dateFormat = initProps.dateFormat
    this.locale = initProps.locale || 'en'
    const iconSize = calculateIconSize(this.props.airportIconSize, 20)
    const dot = L.divIcon({
      iconSize: [iconSize, iconSize],
      html: '<div class="FVLib-ad-dot"></div>'
    })

    this.cities = new FlightViewMapLibCities(this.map, this.props, dot)
    void this.cities.initialize().then(() => {
      this.onMapResize()
      this.mapModule.ready(true)
      this.legend = new FlightViewMapLibADLegend(this, this.mapModule, this.timeFormat, this.dateFormat, this.locale)
      this.scheduleDelaysUpdate(0)
    })
  }

  scheduleDelaysUpdate (time: number) {
    void sleep(time).then(() => {
      getDelays().then((delays) => {
        this.updateDots(delays)
        this.scheduleDelaysUpdate(REFRESH_DELAY)
      }).catch((e) => {
        console.error('Cannot retrieve airport delays', e)
        this.scheduleDelaysUpdate(RETRY_DELAY)
      })
    })
  }

  onMapResize () {
    if (this.props.bounds && this.props.bounds.length === 2) {
      const bounds = new L.LatLngBounds({
        lat: this.props.bounds[0][0],
        lng: this.props.bounds[0][1]
      }, { lat: this.props.bounds[1][0], lng: this.props.bounds[1][1] })
      this.map.fitBounds(bounds, { animate: false, padding: [20, 20] })
    } else if (this.cities) {
      const bounds = this.cities.getBounds()
      this.map.fitBounds(bounds, { animate: false, padding: [20, 20] })
    }
  }

  updateDots (delays: ADAirport[]) {
    delays.forEach((delay) => {
      const element = this.cities.getMarkerElement(delay.airportCode)
      if (element) {
        const dot = element.children[0]
        dot.className = `FVLib-ad-dot FVLib-ad-dot-${this.getMatchingCSSClass(delay.departures)}-${this.getMatchingCSSClass(delay.arrivals)}`
      }
    })
  }

  getMatchingCSSClass (delay: ADDelay) {
    if (delay === ADDelay.OnTime) {
      return 'ontime'
    } else if (delay === ADDelay.Delay) {
      return 'minor'
    } else if (delay === ADDelay.MajorDelay) {
      return 'major'
    } else {
      return ''
    }
  }
}
